






































































import { Vue, Component } from 'vue-property-decorator';
import { Tab, Tabs, Empty, Icon } from 'vant';
import SearchBar from '@/components/next/SearchBar.vue';
import { getRule, getList } from '../api';
import { namespace } from 'vuex-class';

const Module = namespace('CDWMHJZS20201231');

Vue.use(Tab).use(Tabs).use(Empty).use(Icon);

@Component({
  components: {
    SearchBar,
  },
})
export default class Home extends Vue {
  @Module.State articleList!: any[];
  @Module.Action getArticlesAsync!: () => void;

  activeTabIndex = 0;
  rules = '';
  tabContentHeight = 0;
  userSearched = false;
  keyword = '';
  searchResult: any[] = [];
  loading = false;
  async created() {
    const ret = await getRule();
    this.rules = ret.data;
    if (!this.articleList.length) {
      await this.getArticlesAsync();
    }
  }
  mounted() {
    const tabContentWrapperEl = document.querySelector(
      '.content',
    ) as HTMLDivElement;
    const tabItemEl = document.querySelector(
      '.van-tabs__wrap',
    ) as HTMLDivElement;
    this.tabContentHeight =
      tabContentWrapperEl.clientHeight - tabItemEl.clientHeight;
  }
  onNavToDetail(item: any, index: number) {
    this.$router.push(`detail?id=${item.id}`);
  }
  async onSearch() {
    this.loading = true;
    this.userSearched = true;
    const ret = await getList({
      schoolType: '',
      search: this.keyword,
    });
    this.searchResult = ret.data;
    this.loading = false;
  }
  onClear() {
    this.userSearched = false;
    this.searchResult = [];
  }
  onBackFromSearch() {
    this.userSearched = false;
    this.searchResult = [];
  }
}
